import { TQuoteFilters } from '../types'

export const defaultQuoteFilters: TQuoteFilters = {
  isTestQuote: false,
  equipmentParentId: [],
  createdBy: [],
  dropType: [],
}

export const appliedQuoteFilterNames = {
  isTestQuote: 'Test Quotes',
  externalId: 'External ID',
  priceRequestId: 'Price Request ID',
  equipmentParentId: 'Equipment',
  createdBy: 'Created By',
  createdStartDate: 'Priced Start Date',
  createdEndDate: 'Priced End Date',
  shipperApplicationId: 'Shipper',
  pickupCity: 'Pickup City',
  pickupStateCode: 'Pickup State',
  pickupRange: 'Pickup Range',
  deliveryCity: 'Delivery City',
  deliveryStateCode: 'Delivery State',
  deliveryRange: 'Delivery Range',
  isMultiStop: 'Number of Stops',
  dropType: 'Drop Type',
}
